import { render, staticRenderFns } from "./AppIcons.vue?vue&type=template&id=39b1f973&"
import script from "./AppIcons.vue?vue&type=script&lang=js&"
export * from "./AppIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports